module.exports = __webpack_public_path__ + "img/mineral-water.3540f328.svg";